export const commonLinkStyle = 'focus-outline-style';
export const commonButtonStyle = 'focus-button-style';
export const commonBackgroundStyle = 'focus-background-style';

// UI
export const recsCardboardSize = 'Expand H(--recs-card-height)--ml Maw(--recs-card-width)--ml';
